import fetch from './fetch'

export function getContent(id: number): Promise<api.content.GetContentResponse> {
  return fetch.get(`/contents/${id}`).then(res => res.data)
}

export function getContents(bookmark: boolean = false): Promise<api.content.GetContentsResponse> {
  return fetch.get('/contents', { params: { bookmark } }).then(res => res.data)
}

export function contractContents(): Promise<api.content.GetContentsResponse> {
  return fetch.get('/contract_contents').then(res => res.data)
}

export function updateContentBookmarks(ids: number[]): Promise<api.EmptyResponse> {
  return fetch.post('/content_bookmarks', ids).then(res => res.data)
}

export function updateBookmarksStatus(id: number, bookmark: boolean = false): Promise<api.content.GetContentsResponse> {
  return fetch.post(`/contents/${id}/bookmark`, { bookmark }).then(res => res.data)
}
